
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Helmet } from "react-helmet";

export default function Privacy() {
  return (
    <div className="container mx-auto px-4 py-8">
      <Helmet>
        <title>Privacy Policy - UnitCodex</title>
        <meta name="description" content="UnitCodex Privacy Policy - Learn how we handle and protect your information when using our historical unit conversion tools." />
        <link rel="canonical" href="https://unitcodex.com/privacy" />
      </Helmet>
      
      <Card className="bg-manuscript-background/90">
        <CardHeader>
          <CardTitle className="text-4xl font-cinzel text-center">Privacy Policy</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-lg max-w-none text-manuscript-primary/80 space-y-6">
          <section>
            <h2 className="text-2xl font-cinzel mb-4">Overview</h2>
            <p>
              UnitCodex is committed to protecting your privacy. This Privacy Policy explains our practices regarding the limited data we handle when you use our website.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-cinzel mb-4">Information We Don't Collect</h2>
            <p>
              Our unit conversion service operates entirely within your browser. We do not:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Collect personal information</li>
              <li>Store conversion calculations</li>
              <li>Track individual usage patterns</li>
              <li>Require user accounts or registration</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-cinzel mb-4">Automatic Data Collection</h2>
            <p>
              Like most websites, we automatically collect some basic technical information:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>IP addresses (processed by our hosting provider)</li>
              <li>Browser type and version</li>
              <li>Basic usage statistics</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-cinzel mb-4">Google AdSense</h2>
            <p>
              We use Google AdSense to display advertisements. Google AdSense may use cookies and web beacons to collect data, including:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Your IP address</li>
              <li>Browser type and language</li>
              <li>Access times and referring website addresses</li>
            </ul>
            <p className="mt-4">
              This information is processed by Google. Please refer to Google's privacy policy for more details about how they handle this data.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-cinzel mb-4">Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us through our website.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-cinzel mb-4">Updates to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Any changes will be posted on this page.
            </p>
            <p className="mt-2">
              Last updated: {new Date().toLocaleDateString()}
            </p>
          </section>
        </CardContent>
      </Card>
    </div>
  );
}
